var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DivTag } from '../../Utils/AtomicTag';
import { defaultRowProps } from './defaults';
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row(props) {
        return _super.call(this, props) || this;
    }
    Row.prototype.render = function () {
        var ALIGN = {
            start: 'justify-start',
            end: 'justify-end',
            center: 'justify-center',
        };
        var VALIGN = {
            start: 'items-start',
            middle: 'items-center',
            bottom: 'items-end',
        };
        var _a = this.props, className = _a.className, gutter = _a.gutter, valign = _a.valign, align = _a.align, wrap = _a.wrap, children = _a.children, style = _a.style, rest = __rest(_a, ["className", "gutter", "valign", "align", "wrap", "children", "style"]);
        var clsName = [className, !wrap ? 'flex-no-wrap' : '', [VALIGN[valign]], [ALIGN[align]]];
        if (!children) {
            return null;
        }
        if (gutter) {
            var padding_1 = gutter / 2;
            var cols = React.Children.map(children, function (child) {
                return React.cloneElement(child, __assign(__assign({}, child.props), { style: __assign(__assign({}, child.props.style), { paddingLeft: padding_1, paddingRight: padding_1 }) }));
            });
            var styles = __assign(__assign({}, style), { marginLeft: -padding_1, marginRight: -padding_1 });
            return (React.createElement(DivTag, __assign({ name: Row.NAME, className: clsName.join(' ') }, rest, { style: styles }), cols));
        }
        return (React.createElement(DivTag, __assign({ name: Row.NAME, className: clsName.join(' ') }, rest, { style: style }), children));
    };
    Row.NAME = 'row';
    Row.defaultRowProps = defaultRowProps;
    return Row;
}(React.PureComponent));
export default Row;
